import { addUrlParam } from "../utils/addUrlParam.js";
import { urlParam } from "../utils/urlParam.js";
const WP_TABLE_LIST_SELECTOR = ".wp-list-table.media tbody, .wp-list-table.attachments tbody";
function applyToAttachmentsBrowser(attachmentsBrowser, selected, orderby = "rml", order = "ASC") {
    let filter;
    if (attachmentsBrowser && (filter = attachmentsBrowser.toolbar.get("rml_folder").filters[selected.id])) {
        const { props } = attachmentsBrowser.collection;
        const o = {
            silent: true
        };
        if (selected.contentCustomOrder === 1 || selected.forceCustomOrder) {
            filter.props.orderby = "rml";
            filter.props.order = "ASC";
            props.set({
                orderby,
                order
            }, o);
        } else {
            delete filter.props.orderby;
            delete filter.props.order;
            props.set({
                orderby: "date",
                order: "DESC"
            }, o);
        }
    }
}
async function relocateAttachment(message, node, attachmentId, nextId, lastIdInView, ui) {
    if (process.env.PLUGIN_CTX !== "pro") {
        return;
    }
/* Silence is golden... Until you have PRO Version! */ }
function isFilterActive(attachmentsBrowser) {
    if (attachmentsBrowser) {
        const filters = [
            "monthnum",
            "year",
            "uploadedTo",
            "type"
        ];
        const { props } = attachmentsBrowser.collection;
        for(let i = 0; i < filters.length; i++){
            if (props.get(filters[i])) {
                return true;
            }
        }
        return false;
    }
    return !!urlParam("attachment-filter");
}
function isOrderByActive(attachmentsBrowser, orderby = "rml", order = "ASC") {
    if (attachmentsBrowser) {
        const { props } = attachmentsBrowser.collection;
        const propOrder = props.get("order") || "DESC";
        return props.get("orderby") === orderby && propOrder.toUpperCase() === order.toUpperCase();
    }
    const propOrder = urlParam("order") || "DESC";
    return urlParam("orderby") === orderby && propOrder.toUpperCase() === order.toUpperCase();
}
function orderUrl(href = window.location.href) {
    return addUrlParam(addUrlParam(href, "orderby", "rml"), "order", "asc");
}
function toggleSortable(selected, mode, attachmentsBrowser, message) {
    if (process.env.PLUGIN_CTX === "lite") {
        return false;
    }
/* Silence is golden... Until you have PRO Version! */ }
export { WP_TABLE_LIST_SELECTOR, applyToAttachmentsBrowser, orderUrl, relocateAttachment, toggleSortable };
